/* eslint-disable jsx-a11y/label-has-associated-control */

import React from "react";
import { AppTranslation } from "../../../../../../../../../i18n/useAppTranslation";
import { useContext } from "../../../context";
import MembershipBadge from "../../../../../../../../Common/MembershipBadge";

export function Patient() {
  const { appointment } = useContext();

  const isMembershipsVisible =
    appointment.patient?.isMonthlyMembership ||
    ["juvly_member", "both"].includes(appointment.patient?.memberType);

  return (
    <div className="detail-row relative">
      <label>
        <AppTranslation.Common path="label.patient" />:
      </label>
      <span>
        <a
          href={`/clients/profile/${appointment.patientId}`}
          rel="noopener noreferrer"
          target="_blank"
          className="easy-link pull-left no-padding"
        >
          {appointment.patient?.fullName}
        </a>
      </span>
      <div className="TypeOfClient d-flex items-center">
        <div className="d-flex gap-8 m-b-10 items-center">
          {isMembershipsVisible &&
            appointment.patient?.memberships?.map((m, i) => (
              <MembershipBadge
                key={i}
                color={m.color}
                onHold={m.onHold}
                displayPage="appointment-details-popup"
              />
            ))}
        </div>
        {appointment.patient?.type}
      </div>
    </div>
  );
}
